import { render, staticRenderFns } from "./createAudio.vue?vue&type=template&id=52604a8c"
import script from "./createAudio.vue?vue&type=script&lang=js"
export * from "./createAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports